namespace ui
{
	export namespace tab
	{

		export class TabHTMLPresentation<T extends HTMLElement = HTMLDivElement>
			extends ui.base.HTMLPresentation<T>
		{

			protected	m_Entry?: Entry;

			public constructor( tagName?: string )
			{
				super( tagName || 'div' );
			}

			public Entry(): Entry|undefined;
			public Entry( entry: Entry ): TabHTMLPresentation<T>;

			public Entry( entry?: Entry ): Entry|undefined|TabHTMLPresentation<T>
			{
				if ( entry )
				{
					this.m_Entry	= entry;

					return this;
				}

				return this.m_Entry;
			}
		}

	}
}
